import React, { FC, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Country, CountryOverlay, FlagImg } from 'OneWestwingFooter/FooterCountrySelector/CountryOverlay';
import { useCountrySelectorLinks } from 'OneWestwingFooter/FooterCountrySelector/useCountrySelectorLinks';
import useOwwFooterTracking, {
    FOOTER_TRACKING_EVENT_CATEGORY,
} from 'OneWestwingFooter/providers/OwwFooterTrackingProvider';
import { useCurrentPageType } from 'Client/hooks/UrlManager/pageTypeHooks';
import useTranslator from 'Client/hooks/useTranslator';
import ArrowIcon, { Direction } from '@westwing/ui-kit/Icons/ArrowIcon';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const CountrySelectorButton = styled.button`
    cursor: pointer;
    height: 53px;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20New};
    ${forDesktop`
        border-bottom: none;
        width: auto;
        height: auto;
    `}
`;

const StyledCountry = styled(Country)`
    color: ${({ theme }) => theme.colors.charcoal100};
    ${forDesktop`
        color: ${({ theme }) => theme.colors.white};
    `}
`;
const StyledArrowIcon = styled(ArrowIcon)`
    margin-right: 2px;
    color: ${({ theme }) => theme.colors.charcoal70};
    ${forDesktop`
        margin: 0px;
        color: ${({ theme }) => theme.colors.white};
    `}
`;
const CountryName = styled.div`
    flex-grow: 1;
    display: flex;
    ${forDesktop`
        flex-grow: initial;
        display: block;
    `}
`;

export const FooterCountrySelector: FC<{ isClub?: boolean; testId?: string }> = ({ isClub = false, testId }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const { ga } = useOwwFooterTracking();
    const { pageType } = useCurrentPageType();
    const t = useTranslator();

    const countryLinks = useCountrySelectorLinks(isClub);

    const trackOverlayAction = useCallback(
        (action: 'open' | 'close') => {
            ga.trackNonInteractiveGenericEvent(FOOTER_TRACKING_EVENT_CATEGORY, {
                action: `country selector - ${action}`,
                label: pageType,
            });
        },
        [pageType]
    );

    const closeOverlay = () => {
        setIsOverlayOpen(false);
        trackOverlayAction('close');
    };
    const openOverlay = () => {
        setIsOverlayOpen(true);
        trackOverlayAction('open');
    };

    return (
        <>
            <CountrySelectorButton aria-label={t('WestwingNow_worldwide')} onClick={openOverlay}>
                <StyledCountry>
                    <FlagImg src={countryLinks[0].src} alt={countryLinks[0].poKey} />
                    <CountryName>{t(countryLinks[0].poKey)}</CountryName>
                    <StyledArrowIcon direction={Direction.Down} />
                </StyledCountry>
            </CountrySelectorButton>
            <CountryOverlay
                testId={testId}
                countryLinks={countryLinks}
                isOpen={isOverlayOpen}
                dismissFunction={closeOverlay}
            />
        </>
    );
};
